/**
 * Teklif geçerliliği ekranda dakika ya da yalnız gün olarak değil, tarih ve saat olarak yazılır,
 * Dubai saatiyle (13.10.2026 kararı: varsayılan süre 10 gün). Örnek: `16.10.2026 14:30 (Dubai saati)`.
 * Tarayıcının kendi saat dilimi kullanılmaz: aynı teklif İstanbul'da da Dubai'de de aynı yazar.
 */
export function gecerlilikMetni(damga: string): string {
  const tarih = new Date(damga);
  if (Number.isNaN(tarih.getTime())) return damga;
  const parcalar = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Dubai', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(tarih);
  const al = (tur: string) => parcalar.find((p) => p.type === tur)?.value ?? '';
  return `${al('day')}.${al('month')}.${al('year')} ${al('hour')}:${al('minute')} (Dubai saati)`;
}

/**
 * Teklifin süresi doldu mu (ekran kolaylığı). Asıl karar sunucuda ve sunucu saatiyle verilir
 * (`isQuoteExpired`, `createOrGet`); bu işlev yalnız süresi dolmuş teklifin bağlantısının
 * kopyalanmasını ekranda erkenden durdurur. Süre yoksa (taslak) dolmuş sayılmaz.
 */
export function teklifSuresiDolduMu(validUntil: string | null | undefined, simdi: number = Date.now()): boolean {
  if (!validUntil) return false;
  const bitis = new Date(validUntil).getTime();
  return !Number.isNaN(bitis) && bitis <= simdi;
}

/**
 * Düzenleme formunda eski sürümün tarihi taşınırken **elle girilen tarih silinmez**, geçmişte
 * olsa bile (karar 13.10.2026). Ayrım açık bir işaretten gelir (`QuoteVersion.validUntilManual`),
 * zaman farkından çıkarılmaz: yayım anına yakın elle bir tarih varsayılan sanılamaz.
 * Varsayılan tarih (işaret false) taşınmaz; yeni sürüm yayımda yeniden 10 gün alır.
 */
export function tasinacakGecerlilik(damga: string | null | undefined, elle: boolean | undefined): string | null {
  if (!damga || !elle) return null;
  return Number.isNaN(new Date(damga).getTime()) ? null : damga;
}

/** Form günü, kaynak tarihin Dubai gününe eşitse kullanıcı dokunmamıştır: tam damga aynen gönderilir. */
export function gonderilecekGecerlilik(formGunu: string, orijinal: string | null, gunuDubai: (damga: string) => string): string | undefined {
  if (!formGunu) return undefined;
  return orijinal && gunuDubai(orijinal) === formGunu ? orijinal : formGunu;
}

/**
 * Kayda gerçekte yazılacak bitiş anı (sunucunun `parseQuoteValidUntil` kuralıyla aynı): taşınan
 * tam damga aynen, yeni seçilen gün ise Dubai gün sonu. Uyarı ve ipucu bunun üstünden hesaplanır.
 */
export function gecerlilikBitisi(formGunu: string, orijinal: string | null, gunuDubai: (damga: string) => string): Date | null {
  const gonderilecek = gonderilecekGecerlilik(formGunu, orijinal, gunuDubai);
  if (!gonderilecek) return null;
  const tarih = /^\d{4}-\d{2}-\d{2}$/.test(gonderilecek) ? new Date(`${gonderilecek}T23:59:59.999+04:00`) : new Date(gonderilecek);
  return Number.isNaN(tarih.getTime()) ? null : tarih;
}
